/**
 * FUS-2551 — CNPJ alfanumerico.
 *
 * A lib de mascara do projeto e o vue-the-mask@0.11.1, cujos UNICOS tokens sao:
 *   #  -> /\d/           X -> /[0-9a-zA-Z]/   S -> letra
 *   A  -> letra (UPPER)  a -> letra (lower)   ! -> escape
 * O token `N` (usado por outras libs como probil/v-mask) NAO existe aqui: era tratado
 * como caractere LITERAL, e por isso a mascara "NN.NNN.NNN/####-##" renderizava
 * "NN.NNN.NNN/..." e quebrava ate a digitacao de CPF/CNPJ numerico.
 *
 * Registramos um token custom `N` = alfanumerico exibido em MAIUSCULO. Como o
 * vue-the-mask usa APENAS o objeto de tokens recebido (nao faz merge com os defaults),
 * este objeto precisa conter tambem o `#` usado pelas mascaras.
 */
export const cpfCnpjTokens = {
  '#': { pattern: /\d/ },
  N: { pattern: /[0-9A-Za-z]/, transform: value => value.toUpperCase() },
};

// CPF: 11 digitos.
export const cpfMask = '###.###.###-##';

// CNPJ: 12 posicoes alfanumericas (token N) + 2 digitos verificadores (token #).
export const cnpjMask = 'NN.NNN.NNN/NNNN-##';

/**
 * Mascara dinamica para um campo UNICO que aceita CPF OU CNPJ (auto-deteccao por
 * comprimento, feita pelo dynamicMask do vue-the-mask).
 *
 * A mascara "curta" usa N (alfanumerico), NAO `###`: o dynamicMask so troca da mascara
 * de CPF para a de CNPJ quando o valor fica longo o bastante; enquanto isso ele aplica
 * a mascara curta e, se ela fosse so-digito, DESCARTARIA as letras digitadas nas
 * posicoes iniciais do CNPJ ANTES de a troca acontecer -> impossivel digitar o CNPJ
 * alfanumerico. Com N na mascara curta as letras sobrevivem. Para um CPF (so digitos)
 * o resultado e identico a `###.###.###-##`.
 */
export const cpfCnpjMask = ['NNN.NNN.NNN-NN', cnpjMask];

/**
 * Normaliza o valor de um campo CPF/CNPJ para envio a API: remove a mascara
 * (ponto, traco e barra) e forca MAIUSCULO (formato esperado para o
 * federal_tax_number, incluindo o CNPJ alfanumerico).
 */
export const sanitizeCpfCnpj = (value) => {
  if (!value) return '';

  return value.replace(/[.\-/]/g, '').toUpperCase();
};
